import React from 'react'
import classNames from 'classnames'

import './styles.scss'

const Button = ({ children, className, onClick, outline, disabled = false }) => {
  const buttonClassNames = classNames('community_button', className, outline && 'outline')
  return (
    <button className={buttonClassNames} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  )
}
export default Button
